// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bm-4","textarea":"styles_textarea__1nC19"};